export var trimNegativeSpace = 'adb02';